import { render, staticRenderFns } from "./SalesOrderAdd.vue?vue&type=template&id=303b2bc2&"
import script from "./SalesOrderAdd.vue?vue&type=script&lang=js&"
export * from "./SalesOrderAdd.vue?vue&type=script&lang=js&"
import style0 from "./SalesOrderAdd.vue?vue&type=style&index=0&id=303b2bc2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports